import { Grid, Typography } from '@mui/material';
import ActionsPopper from 'pages/selections/components/poppers/ActionsPopper';
import { OptionsCount } from 'pages/variants/common/options-count';
import { styles } from './styles';

interface IVariantItem {
  name: string;
  count: number;
  hasActions: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export const VariantItem = ({ name, count, hasActions, onEdit, onDelete }: IVariantItem) => {
  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.content}>
        <Typography noWrap sx={styles.name}>
          {name}
        </Typography>
        <OptionsCount count={count} />
      </Grid>
      {hasActions && <ActionsPopper handleEdit={onEdit} handleDelete={onDelete} />}
    </Grid>
  );
};
